import { render } from "./WeekClass.vue?vue&type=template&id=0b884e37&scoped=true&ts=true"
import script from "./WeekClass.vue?vue&type=script&lang=ts"
export * from "./WeekClass.vue?vue&type=script&lang=ts"

import "./WeekClass.vue?vue&type=style&index=0&id=0b884e37&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b884e37"]])

export default __exports__